module.exports = __webpack_public_path__ + "static/media/aus.4dbd2017.webp";